<script setup lang="ts">
defineProps<{
  title: string
  totalMkiLabel: string
  canDelete: boolean
}>()

const emit = defineEmits<{
  edit: []
  delete: []
}>()
</script>

<template>
  <v-card class="pa-4 outlined-card">
    <div class="d-flex align-center justify-space-between mb-4">
      <h2 class="text-subtitle-1 font-weight-medium mb-0">{{ title }}</h2>
      <div class="d-flex align-center">
        <v-btn variant="text" append-icon="mdi-menu-down" class="mr-4" @click="emit('edit')">
          Edit chart
        </v-btn>
        <v-btn
          variant="text"
          size="small"
          class="text-caption"
          :disabled="!canDelete"
          @click="emit('delete')"
        >
          Delete
        </v-btn>
      </div>
    </div>
    <div class="chart-wrapper">
      <div class="chart-total-badge text-subtitle-2 font-weight-bold">
        Total MKI: {{ totalMkiLabel }}
      </div>
      <slot />
    </div>
  </v-card>
</template>

<style scoped>
.outlined-card {
  border: 1px solid #c0c0c0;
  border-radius: 10px;
}

.chart-wrapper {
  width: 100%;
  height: 66vh;
  position: relative;
}

.chart-total-badge {
  position: absolute;
  top: 4px;
  right: 8px;
  z-index: 2;
  padding: 2px 10px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.85);
  border: 1px solid #c0c0c0;
  pointer-events: none;
}
</style>
